<template>
  <div class="operation-agent">
    <!-- 侧边栏与主内容区 -->
    <div class="flex max-w-7xl mx-auto px-4 py-8">
      <!-- 侧边栏 -->
      <aside class="w-56 mr-8 hidden md:block">
        <nav class="space-y-2">
          <a 
            v-for="(section, index) in sections" 
            :key="index"
            :href="`#${section.id}`"
            :class="[
              'block px-4 py-2 rounded-lg',
              activeSection === section.id 
                ? 'bg-green-50 text-green-700 font-bold' 
                : 'hover:bg-green-50'
            ]"
            @click.prevent="scrollToSection(section.id)"
          >
            {{ $store.getters.t(section.label) }}
          </a>
        </nav>
      </aside>
      
      <!-- 主内容区 -->
      <main class="flex-1 space-y-8">
        <!-- 客户绑定/解绑管理 -->
        <section id="binding" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-user-lock text-green-600 mr-2"></i>
              客户绑定/解绑管理
            </h2>
            <button
              class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
              @click="goToBindingManagement"
            >
              <i class="fas fa-external-link-alt mr-2"></i>
              管理绑定关系
            </button>
          </div>
          <p class="text-gray-600 mb-4">
            统一管理客户账号与创作者账号的绑定关系，支持分页查看所有绑定记录，并对单条记录执行通过和解绑操作。
          </p>
          <button
            class="bg-green-100 text-green-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-green-200"
            @click="goToBindingManagement"
          >
            <i class="fas fa-list mr-1"></i>
            查看绑定列表
          </button>
        </section>

        <!-- 培训/测评/辅导 -->
        <section id="train" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-chalkboard-teacher text-green-600 mr-2"></i>
              {{ $store.getters.t('train') }}
            </h2>
            <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('add_train') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('train_desc') }}</p>
          <button class="bg-green-100 text-green-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-green-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_train') }}
          </button>
        </section>
        
        <!-- 数据报告/分析/复盘 -->
        <section id="report" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-chart-line text-blue-600 mr-2"></i>
              {{ $store.getters.t('report') }}
            </h2>
            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
              <i class="fas fa-file-alt mr-2"></i>
              {{ $store.getters.t('add_report') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('report_desc') }}</p>
          <button class="bg-blue-100 text-blue-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-blue-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_report') }}
          </button>
        </section>
        
        <!-- 收益计算 -->
        <section id="income" class="bg-white rounded-lg shadow-md p-6 card-hover">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-bold flex items-center">
              <i class="fas fa-coins text-yellow-600 mr-2"></i>
              {{ $store.getters.t('income_calc') }}
            </h2>
            <button class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
              <i class="fas fa-calculator mr-2"></i>
              {{ $store.getters.t('calc_income') }}
            </button>
          </div>
          <p class="text-gray-600 mb-4">{{ $store.getters.t('income_desc') }}</p>
          <button class="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg text-sm font-bold hover:bg-yellow-200">
            <i class="fas fa-magic mr-1"></i>
            {{ $store.getters.t('ai_income') }}
          </button>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationAgent',
  data() {
    return {
      activeSection: 'binding',
      sections: [
        { id: 'binding', label: 'customer_binding' },
        { id: 'train', label: 'train' },
        { id: 'report', label: 'report' },
        { id: 'income', label: 'income_calc' }
      ]
    }
  },
  methods: {
    scrollToSection(sectionId) {
      this.activeSection = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      const sections = this.sections
      const scrollPosition = window.scrollY + 100

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id)
        if (section && section.offsetTop <= scrollPosition) {
          this.activeSection = sections[i].id
          break
        }
      }
    },
    goToBindingManagement() {
      this.$router.push({ name: 'CreatorBindingManagement' })
    }
  },
  mounted() {
    // 监听滚动事件，更新活动区域
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.operation-agent {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.space-y-8 > * + * {
  margin-top: 2rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-600 {
  color: #4b5563;
}

.text-green-600 {
  color: #16a34a;
}

.text-blue-600 {
  color: #2563eb;
}

.text-yellow-600 {
  color: #ca8a04;
}

.bg-green-600 {
  background-color: #16a34a;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.bg-yellow-600 {
  background-color: #ca8a04;
}

.hover\:bg-green-700:hover {
  background-color: #15803d;
}

.hover\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\:bg-yellow-700:hover {
  background-color: #a16207;
}

.text-white {
  color: #ffffff;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.text-sm {
  font-size: 0.875rem;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-yellow-100 {
  background-color: #fef3c7;
}

.text-green-700 {
  color: #15803d;
}

.text-blue-700 {
  color: #1d4ed8;
}

.text-yellow-700 {
  color: #a16207;
}

.hover\:bg-green-200:hover {
  background-color: #bbf7d0;
}

.hover\:bg-blue-200:hover {
  background-color: #bfdbfe;
}

.hover\:bg-yellow-200:hover {
  background-color: #fde68a;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.bg-green-50 {
  background-color: #f0fdf4;
}

.hover\:bg-green-50:hover {
  background-color: #f0fdf4;
}

.text-green-700 {
  color: #15803d;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.w-56 {
  width: 14rem;
}

.mr-8 {
  margin-right: 2rem;
}

.hidden {
  display: none;
}

@media (min-width: 768px) {
  .md\:block {
    display: block;
  }
}

.flex-1 {
  flex: 1 1 0%;
}
</style> 